<style lang='less' scoped>
    .container {
        width: 100%; 
        min-height: 100%;
        display:flex;
        flex-direction:column;
    }

    .header {
        /* background-color: #002D72; */
        padding: 0px;
        width:100%;
        min-height:30vw;
    }
    
    //页头上半部分
    .header-UpperDiv{
        width: 100%;
        height:15vw;
        background:url(../../../public/static/websource/image/tuvsud_vision_mission.jpg);
        background-size:cover;
        background-repeat:no-repeat;
        background-position: 50% 50%;
        display:flex;
        justify-content: space-between;
    }

    .header-UpperDiv-title{
        width: 100%;
        height:2vw;
        background: rgba(0, 0, 0, 0.4);

        display: flex;
        justify-content: space-between;
    }


    .header-UpperDiv-imgText {
        /* background-color: rgb(99, 38, 179); */
        width:50%;
        height:15vw;
        display:flex;
        justify-content: center;
        align-items: center;
        /* font-size: 1.5vw;  //view width */
        font-size: 4.4vmin;
        font-weight:900;
        color:aliceblue;
    }

    /* .header-UpperDiv-right-corner{
        width: 10%;
        height:1.8vw;
        background-color: rgb(99, 38, 179);

        display:flex;
        justify-content: right;
        align-items: center;
    } */

    /* .searchmore{
        text-decoration:none;
        color:aliceblue;
        font-size: 100%;
    } */

   
    //页头下半部分
 

  


    .header-LowerDiv{
        background-color: rgb(242,239,237);
        width: 100%;
        min-height:20vh;
        display:flex;
        justify-content: center;
        align-items: center;
        flex-direction:column;
    }

    .header-LowerDiv-card{
        background-color: rgb(242,239,237);
        width:100%;
        min-height:20vh;
        display:flex;
        justify-content: center;
        align-items: center;
    }

 

    .form{
        width:56vw;
        min-height:20vh;
        display:flex;
        flex-direction:row;
        flex-wrap: wrap;
        justify-content:space-evenly;
        align-items: center;
        /* background-color: #e04903; */
            .el-form-item {
            /* width:45vh; */
            display: flex;
            justify-content: center;
            /* background-color: #4e12da; */
            .el-input {
                width:45vh;
                font-size:small;
             }
            .el-button{
                width:10vh;
            }
        }
    }
    /* .buttonDiv{
         background-color: #37c0a9; 
    } */
  
    
   
    @media screen and (orientation: landscape) {
		.form1 {
		width:100%;
        min-height:20vh;
        display:flex;
        flex-direction:row;
        flex-wrap: wrap;
        justify-content:center;
        align-items: center;
        /* background-color: #e04903; */
            .el-form-item {
            /* width:45vh; */
            display: flex;
            justify-content: center;
            /* background-color: #4e12da; */
            .el-input {
                width:45vh;
                font-size:small;
             }
            .el-button{
                width:15vh;
            }
        }
		}
	}


    @media screen and (orientation: portrait) {
        .form1 {
			width:56vw;
        min-height:20vh;
        display:flex;
        flex-direction:row;
        flex-wrap: wrap;
        justify-content:space-evenly;
        align-items: center;
        /* background-color: #e04903; */
            .el-form-item {
            /* width:45vh; */
            display: flex;
            justify-content: center;
            /* background-color: #4e12da; */
            .el-input {
                width:45vh;
                font-size:small;
             }
            .el-button{
                width:30vh;
            }
        }
		}
    }


    
    //页中响应内容
    .main {
        background-color: rgb(242,239,237);
        width: 100%;
        min-height: 5vmin; /* 30vh */
        display:flex;
        justify-content: center;
        align-items: center;
    }



    //页尾
    .footer{
        background-color: #002D72;
        /* padding: 0px; */
        width:100%;
        height:25vh;//改到这里
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    .footer-left{
        /* background-color: #37c0a9; */
        /* width: 30%;
        height: 50%; */
        min-width: 55%;
        min-height: 14vmin;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .footer-left-text{
        width: 25.74vmax;
        height: 7vmax;
        background:url(../../../public/static/websource/image/footer_text3.png);
        /* background-color: #ffffff; */
        background-size:100% 100%;
        background-repeat:no-repeat;


        display: flex;
        justify-content: center;
        align-items: flex-end;

    }

    .hyperLink{
        width: 25%;
        height: 50%;
        /* background-color: #ffffff;
        background-size:100% 100%; */
        background-repeat:no-repeat;
    }


    .footer-right{
        /* width: 16%;
        height: 50%; */
        width: 12.87vmax;
        height: 7vmax;
        background:url(../../../public/static/websource/image/tuvsud_footer.png);
        /* background-color: #ffffff; */
        background-size:100% 100%;
        background-repeat:no-repeat;
    }

    .highText{
        width:100%;
        height:10vh;
       /*  background-color: #37c0a9;  */
        display: flex;
        justify-content:center;
        align-items: center;
        color: #000000;
        font-size: medium;
        text-align: justify;
        text-justify: newspaper;
    }
    .lowText{
        width:100%;
        height:10vh;
        /* background-color: #37c0a9; */
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000000;
        font-size: medium;
        text-align: justify;
        text-justify: newspaper;
    }


</style>

<template>
    <div  class="container">
        

        <!--页头-->
        <div class="header">

            <div class="header-UpperDiv">

              <div class="header-UpperDiv-title">
                <div class="header-UpperDiv-imgText">
                <p>TÜV SÜD North Asia ReportCertificateQuery</p>
                </div>

                <!-- <div class="header-UpperDiv-right-corner">
                    <a class="searchmore" href="https://www.tuvsud.cn/zh-cn/resource/certificate-finder"  >Search More</a>
                </div> -->
              </div>

            </div>



            <div class="header-LowerDiv">
        
                <div class="highText">
                        <p>TÜV SÜD North Asia Official Query</p>&nbsp;&nbsp;&nbsp;&nbsp;<a class="searchmore" href="https://www.tuvsud.cn/zh-cn/resource/certificate-finder">Search More</a>
                </div>
                    <el-card class="header-LowerDiv-card">
                        
                    <!-- 搜索 -->
                    <el-form :model="formInline1" ref="searchReport" class="form1"  label-width="0" label-position="right">

                    <div>
                    <!--ReportNo-->
                    <el-form-item label="" prop="reportNo"  :rules="NewOneRules.reportNo">
                    <el-input v-model="formInline1.reportNo" placeholder="Please enter the complete report certificate number" ></el-input>
                    </el-form-item>
                    </div>

                    <div>
                    <!--SecurityCode-->
                    <el-form-item label="" prop="securityCode" :rules="NewOneRules.reportNo">
                    <el-input v-model="formInline1.securityCode" placeholder="Please enter the security code" ></el-input>
                    </el-form-item>
                    </div>

                    <div class="buttonDiv">
                    <!--触发按钮-->
                    <el-form-item>
                    <el-button type="success" @click="goDetail('searchReport')"  icon="el-icon-search"></el-button>
                    </el-form-item>
                    </div>
                  
                    </el-form>

                    </el-card>
                    <div class="lowText">
                        <!-- <p>Provided by TÜV SÜD North Asia for testing and verification, through this query, you can verify the authenticity of the report and verify its information.</p> -->
                        <p>Provided by TÜV SÜD North Asia for testing and verification, through this query, you can obtain some key information of the report to verify its authenticity.</p>
                    </div>
            </div>

        </div>

           
        <!--主体-->
        <div class="main">
            <transition name="el-zoom-in-top">
            <router-view :key="$route.fullPath"/>
            </transition>
        </div>
        


        <!-- 页尾 -->
        <div  class="footer">
                <div class="footer-left">

                
                <div class="footer-left-text">
                    <div class="hyperLink" onclick="window.open('https://forms.office.com/e/fCF4egiwVx');"></div>
                </div>

                </div>

                <div class="footer-right">

                </div>

        </div>


     
    </div>
</template>




<script>
    export default {
        data() {
            return {
                activePage: "/home/QueryMenu",
                
                role:'',
                page: 1,
                limit: 10,


                /* 筛选条件表单 */
                formInline1: {
                    /* reportNo: "",
                    securityCode:"", */
                    securityCode: this.$route.query.securityCode,
                    reportNo: this.$route.query.reportNo,
                },
                /* 填写规则限制 */
                NewOneRules: {
                    reportNo: [
                        {
                            required: true,
                            message: "Must input",
                            trigger: "blur",
                        },
                    ],
                },

                /* itemforcarousel:[
                    { url:require("../../../public/static/websource/image/tuvsud_footer.png")},
                    { url:require("../../../public/static/websource/image/tuvsud_vision_mission.jpg")}
                ], */
                itemforcarousel:[],

            }
        },
        mounted() {
            
            localStorage.removeItem("pdfjs.history");
            window.onbeforeunload = function (e) {
                localStorage.removeItem("pdfjs.history");
            }
            /* console.log(this.itemforcarousel) */
            
        },
        methods: {
            /* Part One:搜索 */

            //重置
            Reset() {
                this.$refs.searchReport.resetFields();
            },

            //搜索-跳转详情
            goDetail(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                console.log(this.formInline1.reportNo);
                console.log(this.formInline1.securityCode);
                    if(typeof(this.formInline1.securityCode)=="undefined"){this.formInline1.securityCode="";}
                console.log(this.formInline1.reportNo);
                console.log(this.formInline1.securityCode);
                //判断是否正确
                this.$axios.get(
                        "api/ReportList/TUV_GetReportStatus?securityCode=" +
                        this.formInline1.securityCode+
                        "&reportNo="+
                        this.formInline1.reportNo)
                .then((res) => {
                        console.log("判断是否正确"); 
                        console.log(res.data); 
                        if(res.data.msg=="Active"){
                            console.log("正确");
                            this.$router.push({
                            path: '/home/QueryDetail',
                            query: {
                            securityCode: this.formInline1.securityCode,
                            reportNo: this.formInline1.reportNo,
                            }
                            });
                        }else if(res.data.msg=="Retired"){
                            console.log("Expired or Retired");
                            this.$router.push({path: '/home/RetiredPage',});
                        }else{
                            console.log("错误");
                            this.$router.push({path: '/home/ErrorPage',});
                        }
                    });



                /* this.$router.push({
                    path: '/home/QueryDetail',
                    query: {
                            securityCode: this.formInline1.securityCode,
                            reportNo: this.formInline1.reportNo,
                        }
                }); */

                }
            })
            },



               
        },
    };
</script>

